import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { getPaymentLinksURL } from 'growth-payments-core/urls/urls';
import UIButton from 'UIComponents/button/UIButton';
import { Text } from 'foundations-components/components/Text';
import { Box } from 'foundations-components/transitional/components/Box';
import { track } from '../../../tracking/track';
import { events } from '../../../tracking/events';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaymentLinksModal = props => {
  const {
    handleInterstitialModalClose,
    screen
  } = props;
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: 1000,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      "data-test-id": "interstitial-modal-close-button",
      onClick: handleInterstitialModalClose
    }), /*#__PURE__*/_jsxs(UIFlex, {
      className: "p-all-10",
      children: [/*#__PURE__*/_jsxs(UIBox, {
        children: [/*#__PURE__*/_jsx(UIDialogHeader, {
          children: /*#__PURE__*/_jsx(Text, {
            as: "h2",
            textAlign: "start",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "embedPoints.paymentsInterstitialModal.createAPaymentLink"
            })
          })
        }), /*#__PURE__*/_jsx(UIDialogBody, {
          children: /*#__PURE__*/_jsx(Text, {
            as: "p",
            textAlign: "start",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "embedPoints.paymentsInterstitialModal.embedAPaymentLink",
              options: {
                location: screen.toLowerCase()
              }
            })
          })
        }), /*#__PURE__*/_jsx(UIDialogFooter, {
          children: /*#__PURE__*/_jsx(UIButton, {
            use: "primary",
            external: true,
            href: getPaymentLinksURL(),
            block: true,
            onClick: () => track(events.paymentsInterstitialModalInteraction, {
              action: 'click',
              screen,
              value: 'goToPaymentLinks'
            }),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "embedPoints.paymentsInterstitialModal.goToPaymentLinks"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Box, {
        alignSelf: "center",
        marginInlineStart: "1500",
        children: /*#__PURE__*/_jsx(UIIllustration, {
          alt: "Illustration of a computer screen with a payment link",
          name: "payments",
          width: "50%"
        })
      })]
    })]
  });
};
export default PaymentLinksModal;